import * as React from 'react';

import { noop } from 'lodash';

import type { SourceHelpers } from '../Source/Source';
import type { TaskResponse } from '../TasksWidget/queries';

export type MyTasksContext = {
  myTasks: TaskResponse[];
  myTaskHelpers: SourceHelpers<TaskResponse>;
};

const ContextObject = React.createContext<MyTasksContext>({
  myTasks: [],
  myTaskHelpers: {
    writeToStore: noop,
    deleteFromStore: noop,
  },
});

const { Provider, Consumer } = ContextObject;

const useMyTasks = () => React.useContext(ContextObject);

export { Provider, Consumer, useMyTasks };
